"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../shared/controllers/BaseController");
var DlgSetPProgramPartnerTopCtl = /** @class */ (function (_super) {
    __extends(DlgSetPProgramPartnerTopCtl, _super);
    function DlgSetPProgramPartnerTopCtl() {
        return _super.call(this, true) || this;
    }
    DlgSetPProgramPartnerTopCtl.prototype.ResetData = function () {
        this.DATA = {
            onYes: null,
            dialogTitle: "",
            visible: false,
            onNo: null
        };
    };
    DlgSetPProgramPartnerTopCtl.prototype.IsVisible = function () {
        return this.DATA.visible;
    };
    DlgSetPProgramPartnerTopCtl.prototype.clearFields = function () {
        this.ResetData();
        return this;
    };
    DlgSetPProgramPartnerTopCtl.prototype.Show = function () {
        this.DATA.visible = true;
        this.Update();
        return this;
    };
    DlgSetPProgramPartnerTopCtl.prototype.Close = function () {
        this.DATA.visible = false;
        this.Update();
        return this;
    };
    DlgSetPProgramPartnerTopCtl.prototype.SetOnYesClick = function (callback, forceUpdate) {
        this.DATA.onYes = callback;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgSetPProgramPartnerTopCtl.prototype.GetOnYesClick = function () {
        return this.DATA.onYes;
    };
    DlgSetPProgramPartnerTopCtl.prototype.SetOnNoClick = function (callback, forceUpdate) {
        this.DATA.onNo = callback;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgSetPProgramPartnerTopCtl.prototype.GetOnNoClick = function () {
        return this.DATA.onNo;
    };
    DlgSetPProgramPartnerTopCtl.prototype.SetDialogTitle = function (title, forceUpdate) {
        this.DATA.dialogTitle = title;
        if (forceUpdate) {
            this.Update();
        }
        return this;
    };
    DlgSetPProgramPartnerTopCtl.prototype.GetDialogTitle = function () {
        return this.DATA.dialogTitle;
    };
    return DlgSetPProgramPartnerTopCtl;
}(BaseController_1.BaseController));
exports.DlgSetPProgramPartnerTopCtl = DlgSetPProgramPartnerTopCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/dialogs/ctl/DlgSetPProgramPartnerTopCtl.ts
// module id = 911
// module chunks = 0